import axios from "axios";
var apiBaseUrl = "/api/participe-api/api";
export var apiClient = axios.create({
    baseURL: apiBaseUrl,
});
export var createApiClient = function (accessToken) {
    return axios.create({
        baseURL: apiBaseUrl,
        headers: buildAuthorizationHeaders(accessToken),
    });
};
export var buildAuthorizationHeaders = function (accessToken) {
    if (!accessToken) {
        return {};
    }
    return {
        Authorization: "Bearer ".concat(accessToken),
    };
};
export var getApiBaseUrl = function () { return apiBaseUrl; };
export var getApiErrorMessage = function (error) {
    if (axios.isAxiosError(error)) {
        var responseMessage = extractApiErrorMessage(error);
        if (responseMessage) {
            return responseMessage;
        }
    }
    if (error instanceof Error) {
        return error.message;
    }
    return "Nao foi possivel concluir a requisicao.";
};
var extractApiErrorMessage = function (error) {
    var _a;
    var responseData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
    if (responseData &&
        typeof responseData === "object" &&
        "message" in responseData &&
        typeof responseData.message === "string") {
        return responseData.message;
    }
    return undefined;
};
